// Telefonnummer-Normalisierung für den KI-Telefonisten-Abgleich.
//
// WICHTIG: Diese Funktion ist ein exakter Port von `normalizeGermanPhoneNumber`
// im Backend (nextcab_mobile, functions/src/index.ts). Der KI-Telefonist matched
// eingehende Anrufer per Gleichheit auf das Feld `phoneNumberE164`. Damit der
// schnelle Index-Match greift (statt des 1000er-Fallback-Scans pro Organisation),
// MUSS das Portal die Kundennummer mit derselben Logik nach E.164 normalisieren.
// Bei Änderungen hier auch das Backend anpassen.
export function normalizeGermanPhoneNumber(value) {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed || /^(anonymous|unknown|unbekannt|private)$/i.test(trimmed)) return null;

  let normalized = trimmed.replace(/[^\d+]/g, '');
  if (normalized.startsWith('00')) normalized = `+${normalized.slice(2)}`;
  if (normalized.startsWith('0')) normalized = `+49${normalized.slice(1)}`;
  if (!normalized.startsWith('+')) normalized = `+${normalized}`;
  if (!/^\+[1-9]\d{7,14}$/.test(normalized)) return null;
  return normalized;
}
